import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { BRAND_QUERY_BASE_KEY } from '@/api/brands/queries/get-brands-query'
import { BRAND_MANAGER_AGENT_QUERY_BASE_KEY } from '@/api/agents/queries/get-brand-manager-agent-query'

/** Response of POST .../manager-agent — the comms manager to navigate to. */
export interface IEnterManagerResponse {
    agentUuid: string
}

interface IEnterManagerArgs {
    organizationId: string
    brandSlug: string
}

export class EnterManagerMutation {
    static async call(api: IApi, args: IEnterManagerArgs) {
        return api
            .post<IEnterManagerResponse, undefined>(
                `/organization/${args.organizationId}/brands/${args.brandSlug}/manager-agent`,
                undefined
            )
            .then((res) => res.data)
    }
}

/**
 * Enter the managed product for the current brand: provisions (or resolves) its comms manager and
 * returns the agent uuid to navigate to. Invalidates the brands list and the brand-manager-agent
 * query so the manager surface re-resolves it.
 */
export function useEnterManagerMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<IEnterManagerResponse, void>({
        mutationFn: () => EnterManagerMutation.call(api, apiParams),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: BRAND_QUERY_BASE_KEY })
            qc.invalidateQueries({ queryKey: BRAND_MANAGER_AGENT_QUERY_BASE_KEY })
        },
    })
}
